<template>
    <div class="widget">
        <div class="panel">
            <div class="panel-heading">
                <h2>Workshops<i class="clippie fa fa-info-circle" v-tooltip="'Additional workshops and Live QAs featuring special guests'"></i></h2>
                <div class="toggle-widget" @click="open=!open">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open">
                <VuePerfectScrollbar class="scroll-area">
                    <ul class="class-alerts clearfix" v-if="(upcomingWorkshops && upcomingWorkshops.length > 0) || (pastWorkshops && pastWorkshops.length > 0)">
                        <li v-for="workshop in upcomingWorkshops">                    
                            <a :href="workshop.url" target="_blank">
                                <img src="./../../assets/img/bullhorn.png">
                                <div class="alert-text">
                                    <span class="alert-name">{{workshop.name}}</span>
                                    <br><span>{{workshop.date | shortDate}}</span><br>
                                    <countdown :date="workshop.date"></countdown>
                                </div>
                            </a>
                        </li>

                        <li v-for="workshop in pastWorkshops">
                            <a :href="workshop.archiveUrl" target="_blank">
                                <img src="./../../assets/img/bullhorn.png">
                                <div class="alert-text">
                                    <span class="alert-name">{{workshop.name}}</span>
                                    <br><span style="color:#33ccff">Archive</span>
                                </div>
                            </a>
                        </li>

                    </ul>
                    <p v-else>No workshops scheduled</p>
                </VuePerfectScrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import workshops from '../../services/workshops';
import countdown from '../reusable/countdown/CountdownTimer.vue';

import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    data() {
        return {
            open: true,
            upcomingWorkshops: null,
            pastWorkshops: null
        }
    },
    components: {
        countdown,
        VuePerfectScrollbar
    },
    mounted() {
        this.getWorkshops();
    },
    methods: {
        getWorkshops() {
            var self = this;
            workshops.get(this).then(function(response) {
                const userTimezone = moment.tz.guess();

                const workshops = response.data.workshops.map(function(w) {
                    w.date = w.date.split('T').join(' ').replace('Z', '');
                    w.date = moment.tz(w.date, 'America/Vancouver').tz(userTimezone).toDate();
                    return w;
                });

                self.upcomingWorkshops = workshops.filter(w => !w.recordingReady).sort((a,b)=> {
                    return new Date(a.date) - new Date(b.date);
                });
                
                self.pastWorkshops = workshops.filter(w => w.recordingReady).sort((a,b)=> {
                    return new Date(a.date) - new Date(b.date);
                });
                
            });
        }
    },
    computed: {

    }
}

</script>
<style lang="scss" scoped>
.scroll-area {
    height:400px!important;
    position: relative;
}
.panel-body p {
    text-align: center;
    padding-top: 2rem;
}

h2 {
    margin-bottom: 0;
}

.class-alerts {
    padding-bottom: 0rem;
}

.path-alert {
    padding-top: 0 !important;
    padding-bottom: 0rem;

}

.panel-body {
    background: #222;
}

.panel-body>ul:last-child {
    padding-bottom: 2rem;
}

a {
    color: inherit;
}

ul {
    clear: both;
    padding-bottom: 2rem;
    padding-top: 1.5rem;
}

li {
    padding: 1rem 1rem 1rem 2rem;
    clear: both;
}

h5 {
    margin-bottom: 0;
}

img,
.alert-text {
    display: block;
    float: left;
}

.alert-text {
    padding-left: 1rem;
    max-width: 80%;
}

.alert-name {
    color: white;
}

</style>



// WEBPACK FOOTER //
// Workshops.vue?54806b12